import React, { memo } from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import { Box, IconButton, Link, Stack } from '@mui/material';

import useImageUrlGenerator from '~/hooks/useImageUrlGenerator';

interface ImageLinkWithDeleteProps {
  imageId: string;
  destinationId: string;
  onDelete: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

function ImageLinkWithDelete({ imageId, destinationId, onDelete }: ImageLinkWithDeleteProps) {
  const thumbnailUrl = useImageUrlGenerator(imageId, { width: 160, height: 120, dpr: 2 });
  const fullImageUrl = useImageUrlGenerator(imageId);

  if (!fullImageUrl) {
    return null;
  }

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {thumbnailUrl && (
        <Box
          component="a"
          href={fullImageUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: 'inline-flex',
            borderRadius: 1,
            overflow: 'hidden',
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Box component="img" src={thumbnailUrl} alt={imageId} sx={{ width: 72, height: 56, objectFit: 'cover' }} />
        </Box>
      )}
      <Link href={fullImageUrl} target="_blank" rel="noopener noreferrer" sx={{ fontSize: '0.875rem' }}>
        {imageId}
      </Link>
      <IconButton
        size="small"
        color="error"
        onClick={onDelete}
        aria-label="delete image"
        data-destination-id={destinationId}
        data-image-id={imageId}
      >
        <DeleteIcon fontSize="small" />
      </IconButton>
    </Stack>
  );
}

export default memo(ImageLinkWithDelete);
